let configGame = {
  image: {
    trImage: 'games/page027_game8/img/56969_0_dzieci na plazy_original_tr.png',
    srcImage: 'games/page027_game8/img/56969_0_dzieci na plazy_original127.png',
    srcMask: 'games/page027_game8/img/56969_0_dzieci na plazy_original127_out.png',
    width: 1454,
    height: 753,
    colors: {
      1: '#000000',
      2: '#e1e1e1',
      3: '#e4cbde',
      4: '#09082a',
      5: '#e4cbde',
      6: '#fff463',
      7: '#59596d',
      8: '#c2dfec',
      9: '#59596d',
      10: '#1c6beb',
      11: '#1c6beb',
      12: '#ff792a',
      13: '#eb1c22',
      14: '#15ae5f',
      15: '#eb1c22',
      16: '#c2dfec',
      17: '#eb1c22',
      18: '#79431b',
      19: '#79431b',
      20: '#15ae5f',
      21: '#eb1c22',
      22: '#c2dfec',
      23: '#c2dfec',
      24: '#eb1c22',
    },
    cssStyle: {
      position: 'absolute',
      left: '150px',
      top: '50px',
      border: '1px solid black',
      height: '755px',
      width: '1456px',
    },
  },
  paletteContainer: {
    // cssStyle: { display: 'flex', 'align-items': 'flex-start', 'margin-top': '45px' }, // left palette
    // cssStyle: { display: 'flex', 'align-items': 'flex-start', 'margin-left': '477px' }, // top palette
    cssStyle: { display: 'flex', 'align-items': 'flex-start', 'margin-top': '0', 'margin-left': '1854px' }, // right palette
    // cssStyle: { display: 'flex', 'align-items': 'flex-start', 'margin-left': '477px', 'margin-top': '745px' }, // bottom palette
  },
  palette: {
    // srcPalette: 'games/page003_game2/img/zad_14_2_palette_left.png', // left palette
    // srcPalette: 'games/page003_game2/img//zad_14_2_palette_top.png', // top palette
    srcPalette: 'games/page003_game2/img/paleta_raster.png', // right palette
    // srcPalette: 'games/page003_game2/img/zad_14_2_palette_bottom.png', // bottom palette
    direction: 'vertical',
    colors: {
      1: '#000000',
      2: '#aeafb2',
      3: '#ffffff',
      4: '#e50183',
      5: '#b0c900',
      6: '#009736',
      7: '#e40005',
      8: '#f6a300',
      9: '#ffed00',
      10: '#fccbab',
      11: '#ade7ff',
      12: '#00b6ef',
      13: '#bc00e4',
    },
    // cssStyle: { 'margin-top': '46px', 'margin-left': '11px' }, // left palette
    // cssStyle: { 'margin-top': '11px', 'margin-left': '44px' }, // top palette
    cssStyle: { 'margin-top': '21px', 'margin-left': '15px' }, // right palette
    // cssStyle: { 'margin-top': '24px', 'margin-left': '44px' }, // bottom palette
  },
  color: {
    cssStyle: {
      height: '40px',
      width: '40px',
      // 'background-color': 'yellow',
      'border-radius': '5em',
      'margin-bottom': '15.3px',
      'font-size': '17%', // this affects the width of the ring
    }, // left palette
    // cssStyle: { height: '35.5px', width: '35.5px', 'border-radius': '0.6em', 'margin-right': '26px' }, // top palette
    // cssStyle: { height: '35.5px', width: '35.5px', 'border-radius': '0.6em', 'margin-bottom': '26px' }, // right palette
    // cssStyle: { height: '35.5px', width: '35.5px', 'border-radius': '0.6em', 'margin-right': '26px' }, // bottom palette
  },
};

let dataConfig = {
  realWidth: 1800,
  realHeight: 800,
  withoutCheck: true,
  configGame: configGame,
};

export default dataConfig;
